export function hideSpinner() {
    return {
        type: "HIDE_SPINNER"
    }
}
export function showSpinner() {
    return {
        type: "SHOW_SPINNER"
    }
}

export function ShowLoadingReducer(show = false, action: any) {
    switch (action.type) {
        case "SHOW_SPINNER":
            return true
        case "HIDE_SPINNER":
            return false
        default:
            return show
    }
}
export function hideWaiting() {
    return {
        type: "HIDE_WAITING"
    }
}
export function showWaiting() {
    return {
        type: "SHOW_WAITING"
    }
}
export function  ShowWaitingReducer (show = false, action: any) {
    switch (action.type) {
        case "SHOW_WAITING":
            return true
        case "HIDE_WAITING":
            return false
        default:
            return show
    }
}